// extracted by mini-css-extract-plugin
export var darkMode = "_16-0";